/* eslint-disable import/prefer-default-export */
import type { IApiRouteResponse } from 'types/common';
import type { TWishlist, TWishlistProductPayload } from 'types/wishlist';

interface IResponse extends IApiRouteResponse {
  data: TWishlist;
}

export const fetchAddProductToWishlist = async ({
  wishlistId,
  productId,
}: TWishlistProductPayload): Promise<IResponse> => {
  const response = await fetch('/api/wishlist/add-product', {
    method: 'POST',
    body: JSON.stringify({
      wishlistId,
      productId,
    }),
  });

  return response.json();
};
